import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import FBVideo from "../components/fb-video"

export default ({ data }) => {
  const post = data.markdownRemark
  return (
    <Layout>
      <div>
        <h1>{post.frontmatter.title}</h1>
        <p>by: {post.frontmatter.author} on {post.frontmatter.date} about {post.frontmatter.scripture}</p>
        <FBVideo url={post.frontmatter.video_url} />
        <div dangerouslySetInnerHTML={{ __html: post.html }} />
      </div>
    </Layout>
  )
}

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        author
        date(formatString: "dddd, MMMM Do YYYY, h:mma")
        scripture
        video_url
      }
    }
  }
`